import $ from 'jquery';

var DeviceFormFields = (function () {
  var init = function () {
    checkDeviceTypeFormFields();
    $('#app_device_type').on('change', function () {
      checkDeviceTypeFormFields();
    });

    var productCodeDropdown = $('#app_device_productCode');
    if (productCodeDropdown.has('option').length == 0) {
      loadInnerCodeData();
    }

    $('#app_device_productVariant').on('change', function () {
      productCodeDropdown.find('option').remove();
      productCodeDropdown.dropdown('clear');
      loadInnerCodeData();
    });
  };

  var checkDeviceTypeFormFields = function () {
    var type = $('#app_device_type').val();

    switch (type) {
      case 'set':
        showSetFields();
        break;
      case 'charger':
      case 'holder':
      case 'multi_set':
        showSetCharger();
        break;
    }
  };

  var loadInnerCodeData = function () {
    var productCodeDropdown = $('#app_device_productCode');
    var productVariantId = $('#app_device_productVariant').val();

    if (productVariantId) {
      var url = $('#app_device_productCode').data('url');
      url = url.replace('--productVariant--', productVariantId);
      $.get(url, function (data) {
        $.each(data, function (index, value) {
          productCodeDropdown.append('<option value="' + value + '" selected="selected">' + value + '</option>');
        });
      });
    }
  };

  var showSetFields = function () {
    $(
      '#app_device_holderCodentify, #app_device_holderProduct, #app_device_chargerCodentify, #app_device_chargerProduct',
    )
      .prop('disabled', false)
      .parent()
      .parent()
      .show()
      .removeClass('required');

    $('#app_device_childCodentify').prop('disabled', true).parent().hide().addClass('required');

    var productCodeDropdown = $('#app_device_productCode');
    productCodeDropdown.prop('disabled', true).parent().parent().hide().addClass('required');

    productCodeDropdown.find('option').remove();
    productCodeDropdown.dropdown('clear');
  };

  var showSetCharger = function () {
    $('#app_device_childCodentify').prop('disabled', false).parent().show().addClass('required');

    $('#app_device_productCode').prop('disabled', false).parent().parent().show().addClass('required');

    $(
      '#app_device_holderCodentify, #app_device_holderProduct, #app_device_chargerCodentify, #app_device_chargerProduct',
    )
      .prop('disabled', true)
      .parent()
      .parent()
      .hide()
      .removeClass('required');
  };

  return {
    init: init,
  };
})();

export default DeviceFormFields;
